'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _Api2 = require('./Api');

var _Api3 = _interopRequireDefault(_Api2);

var _uuid = require('../helper/uuid');

var _uuid2 = _interopRequireDefault(_uuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultOptions = {
  domain: window.location.hostname,
  path: '/',
  port: window.location.port,
  protocol: window.location.protocol.replace(':', '')
};

var endpoints = {
  download: {
    ads: {
      body: {
        adAccountId: 'adAccountId',
        adGroups: 'adGroups',
        ads: 'ads',
        brand: 'brand',
        currency: 'currency',
        displayReport: 'displayReport',
        doc_opts: 'doc_opts',
        endDate: 'endDate',
        feeType: 'feeType',
        financialAccess: 'financialAccess',
        initiative: 'initiative',
        lineItem: 'lineItem',
        lineItemFeePercentage: 'lineItemFeePercentage',
        placements: 'placements',
        postAdIds: 'postAdIds',
        publisher: 'publisher',
        readOnly: 'readOnly',
        startDate: 'startDate'
      },
      one: '/download/ads'
    }
  },
  preview: {
    one: '/preview/{record}',
    params: { record: 'key' },
    queryParams: ['srcKey']
  }
};

var PlatformUiApi = function (_Api) {
  (0, _inherits3.default)(PlatformUiApi, _Api);

  function PlatformUiApi(options) {
    (0, _classCallCheck3.default)(this, PlatformUiApi);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PlatformUiApi.__proto__ || (0, _getPrototypeOf2.default)(PlatformUiApi)).call(this, (0, _assign2.default)({}, defaultOptions, options)));

    _this._endpoints = (0, _assign2.default)({}, _this._endpoints, endpoints);
    return _this;
  }

  (0, _createClass3.default)(PlatformUiApi, [{
    key: 'buildHeaders',
    value: function buildHeaders() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var headers = (0, _get3.default)(PlatformUiApi.prototype.__proto__ || (0, _getPrototypeOf2.default)(PlatformUiApi.prototype), 'buildHeaders', this).call(this, state);

      if (!this._options.debug) headers['X-Unified-RequestID'] = (0, _uuid2.default)();

      return headers;
    }
  }]);
  return PlatformUiApi;
}(_Api3.default);

exports.default = PlatformUiApi;
//# sourceMappingURL=PlatformUiApi.js.map